// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;
const classnames = require('classnames');
const { buildArrowIcon } = require('utilities/brokerMarketsHelper')
const { LoadingSection } = require('commonsComponents/loadingSection');
const { requestApi, requestApiIntraday } = require('./helper')
const searchIcon = require('assets/icons/search-close.svg')

const { OKChart } = require('commonsComponents/OKChart');
const BrokerAccordionIndexesTooltip = require('../../brokerMarketsView/brokerAccordionIndexesTooltip/brokerAccordionIndexesTooltip');

// @helpers
const { formatWithoutRound } = require('utilities/currencyHelper');

// @constants
const {
    FILTERS_CHART_INDEXES,
    CHART_PROPS
} = require('constants/brokerMarkets');
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');
const { DATE_FORMAT_SHORT_MONTH_YEAR, DATE_FORMAT_DAY_MONTH } = require('constants/index');

class BrokerAccordionIndexes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filterSelected: 4,
            loadingChart: true,
            dataMedysif: [null, null, null, null, null],
        }
    }

    componentDidMount(){
        const { filterSelected } = this.state
        const { dataChart, originCountry } = this.props
        requestApi(dataChart, filterSelected, originCountry, this.callBackApiOK, this.callBackApiKO)
    }

    callBackApiOK = response => {
        const { filterSelected, dataMedysif } = this.state
        dataMedysif[filterSelected] = response
        this.setState({
            loadingChart: false,
            dataMedysif
        })
    }

    callBackApiKO = response => {
        const { filterSelected, dataMedysif } = this.state
        dataMedysif[filterSelected] = response
        this.setState({
            loadingChart: false,
            dataMedysif
        })
    }

    onClickFilter = value => {
        const { filterSelected, dataMedysif } = this.state
        if(value === filterSelected) return

        if(dataMedysif[value]){
            this.setState({
                filterSelected: value
            })
        } else {
            const { dataChart, originCountry } = this.props
            if(value === 0) {
                requestApiIntraday(dataChart, originCountry, this.callBackApiOK, this.callBackApiKO)
            }else {
                requestApi(dataChart, value, originCountry, this.callBackApiOK, this.callBackApiKO)
            }
            this.setState({
                loadingChart: true,
                filterSelected: value
            })
        }

    }

    buttonsFilterChart = () => {
        const { filterSelected } = this.state
        const buttons = FILTERS_CHART_INDEXES.map((button, index) => {
            const contentGridClassName = classnames(
                'broker-markets-indexes__content-chart__buttons__round-button',
                {
                    '-selected': filterSelected === index
                }
            );
            return (
                <div
                    key={index.toString()}
                    className={contentGridClassName}
                    onClick={() => this.onClickFilter(index)}
                >
                    {formatText(button.label)}
                </div>
            )
        })

        return buttons;
    }

    buildChart = () => {
        const { loadingChart, filterSelected, dataMedysif } = this.state
        const { originCountry } = this.props;

        const labelNameValue = formatText('brokerAccordionIndexes-brokerAccordionIndexes_nameValue');

        if(loadingChart) {
            return (
                <div className="broker-markets-indexes__content-chart">
                    <div className="broker-markets-indexes__content-chart__loading">
                        <LoadingSection />
                    </div>
                    <div className="broker-markets-indexes__content-chart__buttons">
                        {this.buttonsFilterChart()}
                    </div>
                </div>
            )
        }

        const data = dataMedysif[filterSelected]

        if(data.length === 0) {
            return (
                <div>
                    <div className="broker-markets-indexes__container-empty-results">
                        <img src={searchIcon} />
                    </div>
                    <div className="broker-markets-indexes__content-chart__buttons">
                        {this.buttonsFilterChart()}
                    </div>
                </div>
            )
        }

        const chartProps = { ...CHART_PROPS };
        switch(filterSelected) {
            case 0:
                chartProps.formatTime = 'HH:mm';
                chartProps.dataXaxis = 'openDate';
                chartProps.intervalXAxis = "preserveStart";
                break;
            case 1:
                chartProps.formatTime = DATE_FORMAT_DAY_MONTH;
                chartProps.dataXaxis ='date';
                chartProps.intervalXAxis = "preserveStart";
                break;
            case 2:
            case 3:
                chartProps.formatTime = DATE_FORMAT_DAY_MONTH;
                chartProps.dataXaxis ='date';
                chartProps.intervalXAxis = Math.trunc(data.length / 5);
                break;
            case 4:
                chartProps.formatTime = DATE_FORMAT_SHORT_MONTH_YEAR;
                chartProps.dataXaxis ='date';
                chartProps.intervalXAxis = Math.trunc(data.length / 6);
                break;
            default:
                chartProps.formatTime = DATE_FORMAT_SHORT_MONTH_YEAR;
                chartProps.dataXaxis ='date';
        }
        chartProps.showDot = false;

        return (
            <div>
                <OKChart
                    data={data}
                    formatTimeTooltip={DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME}
                    dotTooltip={[true]}
                    customHeight={320}
                    dotTooltipData={['low', CHART_PROPS.dataXaxis]}
                    showTooltip
                    {...chartProps}
                    XaxisScaleType={"point"}

                    customTooltipContent={<BrokerAccordionIndexesTooltip nameValue={labelNameValue} />}
                />
                <div className="broker-markets-indexes__content-chart__buttons">
                    {this.buttonsFilterChart()}
                </div>
            </div>
        )
    }

    render() {
        const { dataChart } = this.props

        const arrow = buildArrowIcon(dataChart.upOrDown === 'down', 'indexes');
        const currency = ` ${dataChart.stockPrice.currency}`;
        const tradeTime = `${dataChart.tradeTime} h`;
        return (
            <React.Fragment>
                <div className="broker-markets-indexes__header-chart">
                    <div className="row">
                        <div className="col-xs-3 broker-markets-indexes__header-chart__title">
                            <div className="broker-markets-indexes__header-chart__index-name">
                                {dataChart.instrumentTranslated}
                            </div>
                        </div>
                        <div className="col-xs-9">
                            <div className="row">
                                <div className="col-xs-2">
                                    <p className="broker-markets-indexes__header-chart__title-sub-section">
                                        <FormattedText value="brokerMarketIndexes-lasTitle"/>
                                    </p>
                                    <p className="broker-markets-indexes__header-chart__content-sub-section">
                                        {formatWithoutRound(dataChart.last)}{currency}
                                    </p>
                                </div>
                                <div className="col-xs-3">
                                    <p className="broker-markets-indexes__header-chart__title-sub-section"><FormattedText value="brokerMarketIndexes-dateHour"/></p>
                                    <p className="broker-markets-indexes__header-chart__content-sub-section">{dataChart.tradeDate} - {tradeTime}</p>
                                </div>
                                <div className="col-xs-2">
                                    <p className="broker-markets-indexes__header-chart__title-sub-section"><FormattedText value="brokerMarketIndexes-minTitle"/></p>
                                    <p className="broker-markets-indexes__header-chart__content-sub-section">{formatWithoutRound(dataChart.low)}</p>
                                </div>
                                <div className="col-xs-2">
                                    <p className="broker-markets-indexes__header-chart__title-sub-section"><FormattedText value="brokerMarketIndexes-maxTitle"/></p>
                                    <p className="broker-markets-indexes__header-chart__content-sub-section">{formatWithoutRound(dataChart.high)}</p>
                                </div>
                                <div className="col-xs-3">
                                    <p className="broker-markets-indexes__header-chart__title-sub-section"><FormattedText value="brokerMarketIndexes-variationTitle"/></p>
                                    <p className="broker-markets-indexes__header-chart__content-sub-section">
                                        {formatWithoutRound(dataChart.netChangePrice.toFixed(2))} | {formatWithoutRound(dataChart.netChangePercentage.toFixed(2))} % {arrow}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.buildChart()}
            </React.Fragment>
        )
    }
}

BrokerAccordionIndexes.propTypes = {
    originCountry: PropTypes.string,
    dataChart: PropTypes.object,
};

export { BrokerAccordionIndexes };
